import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DisabledCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/DisabledCell'
import EmptyCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/EmptyCell'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import type { Column } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { useDropShift } from 'modules/shift_management/hooks/useDragAndDrop'
import type { ShiftsRow } from 'modules/shift_management/lib/types'
import type DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

interface Props {
  shiftsRow: ShiftsRow
  column: Column
  disabled: boolean
  visibleDefaultShifts: DefaultShifts
}

const DailyEmptyCell = ({
  shiftsRow,
  column: { minWidth, date },
  disabled,
  visibleDefaultShifts,
}: Props) => {
  const {
    isOver: isOverParent,
    canDrop,
    drop,
  } = useDropShift({
    shiftsRow,
    date,
  })

  if (disabled) {
    return (
      <WrapperCell minWidth="full">
        <DisabledCell />
      </WrapperCell>
    )
  }

  return (
    <WrapperCell minWidth={minWidth} padding="s4">
      <Box flexDirection="column" height="full" flexGrow ref={drop}>
        <EmptyCell
          date={date}
          shiftsRow={shiftsRow}
          isOver={canDrop && isOverParent}
          visibleDefaultShifts={visibleDefaultShifts}
        />
      </Box>
    </WrapperCell>
  )
}

export default observer(DailyEmptyCell)
